<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Список приложений ({{ applications.length }})</h2>
            </div>
            <div class="column">
                <v-text-field
                    outlined
                    dense
                    hide-details
                    clearable
                    v-model="package_name"
                    @click:clear="onClear"
                    @input="filterApps"
                >
                </v-text-field>
            </div>
            <div class="column">
                <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    icon-right="plus"
                    @click="create()"
                >Добавить</b-button
                >
            </div>
        </div>
        <div style="margin-top: 60px;">
            <div class="draggable-item" v-for="item in applications" :key="item.id">
                <div class="level">
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="title is-4">{{ item.package_name }}</p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered" style="float: right">
                        <div>
                            <b-button icon-right="chevron-right" @click="edit(item)"
                            >Редактировать</b-button
                            >
                            <b-tooltip label="Удалить">
                                <b-button
                                    v-if="item.id !== 1"
                                    type="is-danger"
                                    icon-right="delete"
                                    @click="remove(item)"
                                >
                                </b-button>
                            </b-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: "AdminLandingsList",
    components: {
        draggable,
    },
    data() {
        return {
            package_name: "",
        };
    },
    created() {
        this.$store.dispatch("GET_APPLICATIONS",{});
    },
    computed: {
        applications: {
            get() {
                return this.$store.getters.APPLICATIONS;
            },
            set(value) {
                this.$store.commit("SET_APPLICATIONS", value);
            },
        },
    },
    methods: {
        edit(application) {
            this.$router.push({ path: `/admin/landing_applications/update/${application.id}` });
        },
        create() {
            this.$router.push({ path: "/admin/landing_applications/create" });
        },
        remove(application) {
            this.$store
                .dispatch("DELETE_APPLICATION", application.id)
                .then(() => {
                    this.$toaster.success("Приложение удалено");
                    this.$store.dispatch("GET_APPLICATIONS",{});
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                });
        },
        onClear() {
            this.$store.dispatch("GET_APPLICATIONS",{});
        },
        filterApps() {
            const params = {
                package_name: this.package_name,
            };
            this.$store.dispatch("GET_APPLICATIONS", params);
        },
    },
};
</script>

<style>
.draggable-item {
    border: 1px solid rgba(0, 0, 0, 0.125);
    padding: 10px;
    background-color: #fff;
}
</style>
